export default __webpack_public_path__ + "static/media/Document_PDF_LW.12de32d0.svg";